import { combineReducers } from '@reduxjs/toolkit';
import expandedRow from './expandedRow/root';
import modals from './modals/root';

const root = combineReducers({ expandedRow, modals });

export default root;
